import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://vfqdecxypfdkntjammbt.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZmcWRlY3h5cGZka250amFtbWJ0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAxMTc3NTcsImV4cCI6MjA4NTY5Mzc1N30.JEJ2-kll5dNo7-SljQLjtJD559soTOSfHbieUfSQy0k'

// The anon key is public by design — it ships in the bundle. What protects client
// data is Row Level Security plus the session established at sign-in, which is why
// the session has to survive a reload rather than being re-entered every visit.
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { persistSession: true, autoRefreshToken: true },
})
